<template>

  <div class="col  mt-3">
    <div class="el-button-group mb-3">

      <router-link tag="el-button" class="el-button--medium" active-class="el-button--primary"
                   to="/gider/odeme" type="default">{{$t('fatura.odeme')}}
      </router-link>
      <router-link tag="el-button" class="el-button--medium" active-class="el-button--primary"
                   to="/gider/fatura" type="default">{{$t('fatura.fatura')}}
      </router-link>

    </div>
    <router-view></router-view>
  </div>

</template>

<script>
    export default {
        data() {
            return {

            }
        },
        methods: {

        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Module/gider/_route.vue